import { Offer } from '@funtech-int/yango-shared';
import { SportEventState } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function getOfferButtonText(offer: Offer, eventState: SportEventState) {
    if (eventState === 'LIVE') {
        return offer.offerTexts?.customTexts?.buttonTextNow;
    }

    if (eventState === 'ANNOUNCE') {
        return offer.offerTexts?.customTexts?.buttonTextFuture;
    }

    return offer.offerTexts?.customTexts?.buttonTextPast;
}
